//import { Tooltip } from 'primereact/tooltip';
import React from 'react';

import targetArrow from '../../assets/targetArrow.svg';
//import trendDown from '../../assets/trendDown.svg';
//import trendUp from '../../assets/trendUp.svg';
import './metricProgressDirection.scss';

interface MetricProgressDirectionProps {
    metricDirectionId?: number | null;
    trendPercentage?: number | string;
    sType: string;
    //metricAttained?: boolean;
}

const MetricProgressDirection = (props: MetricProgressDirectionProps) => {
    //const metricAttainedLabel = props.metricAttained ? 'Metric Met' : 'Metric Not Met';
    const target = `tooltip${props.metricDirectionId}`;
    return (
        <div className={`direction_container  ${target}`}>
            <img src={targetArrow} alt="targetArrow" style={{height:'20px'}}/>&nbsp;
            Target : {props.trendPercentage && <div>{props.trendPercentage}{props.sType}</div>}
            {!props.trendPercentage && <div>0.00</div>}
            {/* <div className="divider">&nbsp;</div> */}
            {/* {props.metricDirectionId && (
                <img src={props.metricDirectionId === 1 ? trendUp : trendDown} alt="trendUp" />
            )} */}
            {/* <Tooltip target={`.${target}`} mouseTrack mouseTrackLeft={10}>
                {label}
            </Tooltip> */}
        </div> 
    );
};

export default MetricProgressDirection;
